import { TextKey, RouteName } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { getCurrentEnterpriseChainId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { hasCurrentEnterpriseServiceProviderMode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { AssistantNavigation } from './AssistantNavigation';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { useNavigationPath } from './useNavigationPath';

export const useExportNavigation = (): AssistantNavigation[] => {
    const params = { query: { OwnerId: getCurrentEnterpriseChainId } };

    const localizeText = useLocalizeText();

    const parentPath = `${localizeText({ textKey: TextKey.ExportPlural })}${UnicodeEntity.Space}${
        UnicodeEntity.ForwardSlash
    }${UnicodeEntity.Space}`;

    const hasServiceProviderMode = useCommanderSelector<boolean>(hasCurrentEnterpriseServiceProviderMode);
    const isPlatformAdmin = useCommanderSelector<boolean>(isCurrentProfilePlatformAdmin);
    const archiveResult = useNavigationSearchResult(
        RouteName.ExportIndex,
        TextKey.Archive,
        {},
        useNavigationPath(parentPath, TextKey.Archive)
    );
    const schedulesResult = useNavigationSearchResult(
        RouteName.ExportScheduleIndex,
        TextKey.Schedules,
        params,
        useNavigationPath(parentPath, TextKey.Schedules)
    );
    const targetsResult = useNavigationSearchResult(
        RouteName.ExportTargetIndex,
        TextKey.Targets,
        params,
        useNavigationPath(parentPath, TextKey.Targets)
    );

    if (!isPlatformAdmin && !hasServiceProviderMode) {
        return [];
    }

    return [archiveResult, schedulesResult, targetsResult];
};
